<template></template>

<script setup lang="ts">
import { getUserLocationCountryCode } from '@/helpers/geo-location-helper';
import { onMounted } from 'vue';

onMounted(() => {
	let path = '/';
	const userCountry = getUserLocationCountryCode();

	switch (userCountry) {
		case 'AT':
			path = '/at/Film/mission-impossible-dead-reckoning-teil-zwei';
			break;
		case 'CH':
			path = '/ch/Film/mission-impossible-dead-reckoning-teil-zwei';
			break;
		case 'DE':
			path = '/de/Film/mission-impossible-the-final-reckoning';
			break;
	}

	window.location.href = path;
});
</script>
